import React, { Fragment, PureComponent } from "react";
import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";

import Button from "../../Common/Button";
import PanelMobileNavigationMenu from "./PanelMobileNavigationMenu";

export default class PanelHeaderMenu extends PureComponent {
  static propTypes = {
    isFirstPage: PropTypes.bool,
    isMobile: PropTypes.bool
  };

  static defaultProps = {
    isFirstPage: false,
    isMobile: false
  };

  state = {
    isMenuVisible: false
  };

  handleBackClick = () => window.history.back();

  handleMenuClick = () => this.setState({ isMenuVisible: !this.state.isMenuVisible });

  render() {
    return (
      <Fragment>
        <PanelMobileNavigationMenu isMenuVisible={this.state.isMenuVisible} onBackButtonClick={this.handleMenuClick} isMobile={this.props.isMobile} />

        {this.props.isMobile && (
          <div className="panel-header__menu-icons">
            {!this.props.isFirstPage && (
              <div className="panel-header__menu-icon">
                <Button className="panel-header__back-arrow" icon="back" onClick={this.handleBackClick} />
              </div>
            )}

            {this.props.isFirstPage && <Button className="panel-header__menu-icon" icon="menu" onClick={this.handleMenuClick} />}

            <UISref to="advanced-search">
              <Button className="panel-header__menu-icon" icon="advanced-search" />
            </UISref>
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelHeaderMenu.js